import {
  residential,
  mobile,
  datacenter,
  ProxyTypeName,
} from '@fd/common/biz/proxyType';
import ProxyIcon from '../assets/icons/ProxyIcon';
import { ReactNode } from 'react';

type PaymentModel = {
  id: string;
  title: string;
  description: string;
  price: string;
};

const sharedPaymentModel = {
  id: 'shared-gb',
  title: 'Shared',
};

export type ProxyInfoType = {
  type: ProxyTypeName;
  title: string;
  description: string;
  bullets: string[];
  icon: ReactNode;
  paymentModels: PaymentModel[];
  defaultQuantity: number;
  price: number;
  minQuantity: number;
};

export const residentialProxy: ProxyInfoType = {
  type: residential.name,
  title: 'Residential',
  description:
    "Real home IP addresses from around the world. Websites see you as an ordinary user from your chosen location.",
  bullets: ['Generate leads', 'Run ads', 'Scrape data'],
  icon: <ProxyIcon type="residential" className="h-7 w-7 stroke-white" />,
  paymentModels: [
    {
      ...sharedPaymentModel,
      price: `$${residential.price} / GB`,
      description:
        'Home IPs shared by multiple users with automatic IP rotation.',
    },
  ],
  defaultQuantity: 20,
  price: residential.price,
  minQuantity: 2,
};

export const mobileProxy: ProxyInfoType = {
  type: mobile.name,
  title: 'Mobile',
  description:
    'Route your traffic through real 4G/5G mobile IPs. Websites detect you as a smartphone user from any country',
  bullets: [
    'Manage multiple accounts',
    'Protect your privacy',
    'Perform freelance jobs',
  ],
  icon: <ProxyIcon type="mobile" className="h-7 w-7 stroke-white" />,
  paymentModels: [
    {
      ...sharedPaymentModel,
      price: `$${mobile.price} / GB`,
      description:
        'Phone network IPs shared among users with rotating connections.',
    },
  ],
  defaultQuantity: 20,
  price: mobile.price,
  minQuantity: 2,
};

export const datacenterProxy: ProxyInfoType = {
  type: datacenter.name,
  title: 'Datacenter',
  description:
    "Fast and budget-friendly, best for tasks where speed matters more than stealth, but websites can spot they're not real home connections.",
  bullets: ['Bypass geo-blocks', 'Monitor prices'],
  icon: <ProxyIcon type="datacenter" className="h-7 w-7 stroke-white" />,
  paymentModels: [
    {
      ...sharedPaymentModel,
      price: `$${datacenter.price} / GB`,
      description:
        'Server facility IPs shared by multiple users with rotating addresses.',
    },
  ],
  defaultQuantity: 20,
  price: datacenter.price,
  minQuantity: 5,
};

export const proxies = [residentialProxy, mobileProxy, datacenterProxy];
export const proxiesByType = {
  [residentialProxy.type]: residentialProxy,
  [mobileProxy.type]: mobileProxy,
  [datacenterProxy.type]: datacenterProxy,
};
